import TestA from '@/components/widgets/TestA.vue'
import TestB from '@/components/widgets/TestB.vue'
import TestC from '@/components/widgets/TestC.vue'
import TestD from '@/components/widgets/TestD.vue'
import CirclesPercentage from '@/components/widgets/CirclesPercentage.vue'
import DataTable from '@/components/widgets/DataTable.vue'
import PieChart from '@/components/widgets/PieChart.vue'
import LineVerticalChart from '@/components/widgets/LineVerticalChart.vue'
import RangeBarChart from '@/components/widgets/RangeBarChart.vue'

export default [
    TestA,
    TestB,
    TestC,
    TestD,
    CirclesPercentage,
    DataTable,
    PieChart,
    LineVerticalChart,
    RangeBarChart
]
